import { render, staticRenderFns } from "./icon-header-add.vue?vue&type=template&id=5b5ae99f&"
import script from "./icon-header-add.vue?vue&type=script&lang=js&"
export * from "./icon-header-add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports